<template>
  <b-form-group
    label="Adı Soyadı"
    :label-for="'name_' + itemKey"
  >
    <b-form-input
      :id="'name_' + itemKey"
      v-model="dataItem.related_persons[itemKey].name"
      placeholder="Adı Soyadı"
    />
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'Name',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  props: {
    itemKey: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['customers/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
